import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "Paragraph"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", { d: "M20.25 3H9.75C8.35761 3 7.02226 3.55312 6.03769 4.53769C5.05312 5.52226 4.5 6.85761 4.5 8.25C4.5 9.64239 5.05312 10.9777 6.03769 11.9623C7.02226 12.9469 8.35761 13.5 9.75 13.5V21H11.25V4.5H15V21H16.5V4.5H20.25V3ZM9.75 12C8.75544 12 7.80161 11.6049 7.09835 10.9017C6.39509 10.1984 6 9.24456 6 8.25C6 7.25544 6.39509 6.30161 7.09835 5.59835C7.80161 4.89509 8.75544 4.5 9.75 4.5V12Z" }, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/Paragraph.vue"]]);
